<template>
  <v-layout align-center class="primary_dark" mx-0 row wrap>
    <v-flex xs12 sm12 md6>
      <v-img width="100%" :src="image"></v-img>
    </v-flex>
    <v-flex xs12 sm12 md6>
      <v-layout align-center justify-center row wrap>
        <v-flex xs9 sm9 md8>
          <vc-simulator :selector="true"></vc-simulator>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<style scoped>
.bg-accent-dark {
  background-color: #f9a61b !important;
}
</style>
<script>
export default {
  props: ["image", "imgleft"],
  data() {
    return {};
  }
};
</script>